import React, { Component } from "react";
import TransactionTypeCards from "./TransactionTypeCards";
import { connect } from "react-redux";
import { Paper } from "@material-ui/core";
import {
  setSipDetails,
  setSwitchDetails,
  setStpDetails,
  setNewPAN,
  EnachUMR,
  EnachFolio,
  Enachbank,
} from "../../../store/actions";
import {
  PHYSICAL_NEW,
  PHYSICAL_ADD,
  PHYSICAL_RED,
  PHYSICAL_SWITCH,
  PHYSICAL_SIP,
} from "../../../store/types";
import { NEW_TRANSACTION_URL } from ".";

class TransactionType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pan: {
        value:
          !!this.props.location.state && !!this.props.location.state.pan
            ? this.props.location.state.pan
            : !!this.props.newPan
              ? this.props.newPan
              : "",
      },
    };
  }
  componentDidMount() {
    this.props.EnachUMR("");
    this.props.EnachFolio("");
    this.props.Enachbank("");
    if (!!this.props.location.state && !!this.props.location.state.pan) {
      this.props.setNewPAN(this.props.location.state.pan);
    }
    const payload = {};
    this.props.setSipDetails(payload);
    this.props.setSwitchDetails(payload);
    this.props.setStpDetails(payload);
  }

  render() {
    const { showAll } = this.props;

    return (
      <div className="container-margin">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "30px 20px 10px",
            marginBottom: 30,
          }}
        >
          <div className="transaction-type-title">Select Transaction Type</div>
          <div className="physical-digital-modes">
            <button className="know-about-physical-digital-button">
              Know about Digital Mode
            </button>
            <div className="descripton-about-physical-digital-mode">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginRight: 25,
                }}
              >
                <div className="know-about-physical-digital-arrow-up" />
              </div>
              <Paper className="know-about-physical-digital-paper">
                {/* <div
                  style={{
                    fontSize: 15,
                    padding: "10px 0px",
                  }}
                >
                  Phygital Mode
                </div>
                <div style={{ fontSize: 14 }}>
                  Please Follow The Below Steps
                </div> */}
                {/* <div className="transaction-mode-img-div">
                  <div>
                    <Image
                      src={"/images/stages1.png"}
                      style={{
                        width: 8,
                        height: 80,
                        margin: "5px 0px 3px 0px",
                      }}
                      alt="stages"
                    />
                  </div>
                  <div className="transaction-mode-physical-upload-div">
                    <div className="transaction-mode-physical-upload">
                      Upload Order form
                    </div>
                    <div className="transaction-mode-physical-upload">
                      Upload Cheque
                    </div>
                    <div className="transaction-mode-physical-upload">
                      Sumbit Cheque at nearest Kfintech Branch
                    </div>
                  </div>
                </div> */}

                <div
                  style={{
                    fontSize: 15,
                    padding: "10px 0px",
                  }}
                >
                  Digital Mode
                </div>
                <div
                  style={{
                    fontSize: 14,
                    margin: "10px 0px",
                  }}
                >
                  Digital mode lets you do all the transactions digitally
                  without any effort to physically submit the transactions of
                  your Investors.
                </div>
              </Paper>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            marginBottom: !showAll ? 30 : 160,
          }}
          className="transt-type-whole-div"
        >
          <TransactionTypeCards
            image={"/images/bajaj_new_purchase.svg"}
            name="New Purchase + SIP (New Folio)"
            history={this.props.history}
            pan={
              !!this.props.location.state && !!this.props.location.state.pan
                ? this.props.location.state.pan
                : this.state.pan.value
            }
            navigationProps={{
              physical:
                NEW_TRANSACTION_URL + "/nfo-new-purchase/physical/transact",
              type: PHYSICAL_NEW,
            }}
          />

       {!!showAll && (
          <React.Fragment>
            <TransactionTypeCards
              image={"/images/bajaj_additional_purchase.svg"}
              name="NFO & Additional Purchase"
              history={this.props.history}
              navigationProps={{
                physical:
                  NEW_TRANSACTION_URL +
                  "/additional-purchase/physical/transact",
                type: PHYSICAL_ADD,
                flag: "pSchFlg",
              }}
            />
            <TransactionTypeCards
              image={"/images/bajaj_sip.svg"}
              pan={
                !!this.props.location.state && !!this.props.location.state.pan
                  ? this.props.location.state.pan
                  : this.state.pan.value
              }
              name="SIP"
              history={this.props.history}
              navigationProps={{
                physical: NEW_TRANSACTION_URL + "/sip/physical/transact",
                type: PHYSICAL_SIP,
              }}
            />
            <TransactionTypeCards
              image={"/images/bajaj_redemption.svg"}
              name="Redemption"
              history={this.props.history}
              navigationProps={{
                physical:
                  NEW_TRANSACTION_URL + "/redemption/physical/transact",
                type: PHYSICAL_RED,
                flag: "rSchFlg",
              }}
            />

            <TransactionTypeCards
              image={"/images/bajaj_switch.svg"}
              name="Switch"
              history={this.props.history}
              navigationProps={{
                physical: NEW_TRANSACTION_URL + "/switch/physical/transact",
                type: PHYSICAL_SWITCH,
                flag: "sSchFlg",
              }}
            />
          </React.Fragment>
        )}



         {!!showAll && ( 
          <React.Fragment>
            <TransactionTypeCards
              image={"/images/bajaj_stp.svg"}
              name="STP"
              history={this.props.history}
            />

            <TransactionTypeCards
              image={"/images/bajaj_swp.svg"}
              name="SWP"
              history={this.props.history}
            />
            <TransactionTypeCards
                image={"/images/bajaj_sip_cancel.svg"}
                name="Pause/Cancellation"
                history={this.props.history}
              />
            {/* <TransactionTypeCards
              image={"/images/bajaj_nct.svg"}
              name="NCT"
              history={this.props.history}
            /> */}
            <TransactionTypeCards
              image={"/images/bajaj_enach.svg"}
              pan={
                !!this.props.location.state && !!this.props.location.state.pan
                  ? this.props.location.state.pan
                  : ""
              }
              name="eNACH"
              history={this.props.history}
            />
          </React.Fragment>
         )}  
        </div>
        {/* {!showAll && ( */}
        {/* <div
          style={{
            fontSize: 14,
            marginLeft: 15,
            color: "#194b7e",
          }}
        >
          <span>Note:</span> For a new Investor, only ISIP facility is
          available to register the SIP.
        </div> */}
        {/* )} */}
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const { showAll } = authReducer;
    const { newPan } = transactions;
    return { showAll, newPan };
  },
  {
    setSipDetails,
    setSwitchDetails,
    setStpDetails,
    setNewPAN,
    EnachUMR,
    EnachFolio,
    Enachbank,
  }
)(TransactionType);
